import { useSuspenseQuery } from "@tanstack/react-query";
import { authenticatedFetch } from "api/authenticatedFetch";
import { getMemberHost } from "config";

export type RolloverPeriodResponse = {
  programTermsRolloverPeriod: number;
};

export const useRolloverPeriod = (advertiserId: number) => {
  const { data } = useSuspenseQuery({
    queryKey: ["rollover-period", advertiserId],
    queryFn: async () => {
      const response = await authenticatedFetch<RolloverPeriodResponse>(
        `https://${getMemberHost()}/affapi/advertiser/${advertiserId}/programterms/rollover-period`
      );
      return response.programTermsRolloverPeriod;
    },
  });

  return data;
};
